import { defineStore } from "pinia";
import Services from '@/services/employmentRecordServices'
import { mapEmploymentRecord } from '@/helpers/mapFuncs'

export const useEmploymentRecordStore = defineStore("employmentRecord", {

state:()=>({
    employmentRecord: {},
    employmentRecords: [],
}),
getters : {
    getEmploymentRecord() {
        return mapEmploymentRecord(this.employmentRecord)
    },
    getEmploymentRecords() {
        return this.employmentRecords.map(mapEmploymentRecord)
    }
},
actions : {
    /** Start Sets */
    setEmploymentRecord(employmentRecord) {
        this.employmentRecord = employmentRecord
    },
    setEmploymentRecords(employmentRecords) {
        this.employmentRecords = employmentRecords
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setEmploymentRecord(response.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setEmploymentRecord(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setEmploymentRecords(response.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.employmentRecords.push(response.data)
            return mapEmploymentRecord(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.employmentRecords[this.employmentRecords.findIndex((x)=>x.id == id)] = response.data
            return mapEmploymentRecord(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.employmentRecords = this.employmentRecords.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});